import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    maxWidth: theme.space.basicDataMaxWidth,
    margin: '32px auto 0 auto',
    padding: '0 0 240px 0',
    [theme.breakpoints.down('sm')]: {
      width: 'unset',
      maxWidth: 'unset',
      margin:'24px -16px 72px -16px',
    },
  },
}), {name: 'SetAmountsPerFund'});
